var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoupe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.28455 0C2.37073 0 0 2.37073 0 5.28455C0 8.19853 2.37073 10.5691 5.28455 10.5691C8.19853 10.5691 10.5691 8.19853 10.5691 5.28455C10.5691 2.37073 8.19853 0 5.28455 0ZM5.28455 9.59351C2.90862 9.59351 0.97561 7.6605 0.97561 5.28457C0.97561 2.90864 2.90862 0.97561 5.28455 0.97561C7.66048 0.97561 9.59349 2.90862 9.59349 5.28455C9.59349 7.66048 7.66048 9.59351 5.28455 9.59351Z",
    fill: "#B5B5B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8571 11.1672L9.06035 8.37047C8.86978 8.1799 8.56116 8.1799 8.37059 8.37047C8.18002 8.56087 8.18002 8.86983 8.37059 9.06023L11.1673 11.857C11.2626 11.9523 11.3873 11.9999 11.5122 11.9999C11.6369 11.9999 11.7618 11.9523 11.8571 11.857C12.0477 11.6666 12.0477 11.3576 11.8571 11.1672Z",
    fill: "#B5B5B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoupe);
export default __webpack_public_path__ + "static/media/loupe.e771cd78e630118355001535a5bffa5d.svg";
export { ForwardRef as ReactComponent };